import './Error.css';

export default function ErrorDisplay({ errorData }) {
    if (!errorData) return null;
    return (
        <div className='error-display'>
            <strong>Error:</strong> {errorData.message || String(errorData)}
        </div>
    );
}